import { PageState } from './types'
import { MAX_IMPORT_FILES, MAX_IMPORT_FILE_SIZE_BYTES, megabytes } from './utils'

/** Hero title for each page state. */
export const titleForState = (s: PageState): string => {
	switch (s) {
		case 'idle':
			return 'Import to your itinerary'
		case 'processing':
			return 'Adding to your itinerary'
		case 'success':
			return 'Trip booked! Mission accomplished'
		case 'no_events':
			return "Couldn't find any events"
		case 'failed':
			return 'Import failed'
		case 'rate_limit':
			return 'Daily import limit reached'
		case 'stuck':
			return 'Looks like that import got stuck'
	}
}

/**
 * The footer CTA. It names what is about to be sent, so the count of attached
 * files is part of the label; text on its own imports under the bare verb.
 */
export const importCtaLabel = (fileCount: number): string => {
	if (fileCount <= 0) return 'Import'
	return `Import ${fileCount} file${fileCount === 1 ? '' : 's'}`
}

/**
 * The accepted kinds, as prose. The MIME list behind it is pinned to the
 * contract's by `__tests__/importLimits.test.ts`, so this only has to read well.
 */
const ACCEPTED_KINDS = 'PDF, image, or text'

/** The drop zone's limits line — every number from the shared import limits. */
export const fileLimitsLine = (): string =>
	`${ACCEPTED_KINDS} · Up to ${megabytes(MAX_IMPORT_FILE_SIZE_BYTES)} MB · ${MAX_IMPORT_FILES} files`
